import { render, staticRenderFns } from "./myVip.vue?vue&type=template&id=0d7e8637&scoped=true&"
import script from "./myVip.vue?vue&type=script&lang=js&"
export * from "./myVip.vue?vue&type=script&lang=js&"
import style0 from "./myVip.vue?vue&type=style&index=0&id=0d7e8637&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7e8637",
  null
  
)

export default component.exports